import React, { useCallback } from 'react';
import { map } from 'rxjs/operators';

import { EntityCollectionAutocomplete, EntityCollectionAutocompleteProps } from 'app/components';
import { GeneralConstants } from 'app/constants';
import { Store } from 'app/model';
import { searchService } from 'app/services';

type EntityStoreCollectionAcProps<T extends object> = Omit<
    EntityCollectionAutocompleteProps<T, Store>,
    'getOptionLabel' | 'onSearch'
>;

const getOptionLabel = (option: Store) => option.name;

export const EntityStoreCollectionAc = <T extends object>(
    props: EntityStoreCollectionAcProps<T>,
): React.ReactElement => {
    const onSearch = useCallback(
        (data: string) =>
            searchService.search(data, 1, GeneralConstants.PAGE_SIZE_LARGE).pipe(
                map((page) => {
                    const results: Store[] = [];
                    page.data.map((brand) => results.push(...(brand.stores ?? [])));

                    return {
                        ...page,
                        data: results,
                    };
                }),
            ),
        [],
    );

    return <EntityCollectionAutocomplete {...props} getOptionLabel={getOptionLabel} onSearch={onSearch} />;
};
